
module.exports=function(data){
    if(data&&data.length>0){
        return data.map((item)=>{
           return {
            id: item._id,
            number: item.number,
            name: item.title,
            menu: item.menu?true:false,
            radio: item.radio?true:false,
            chat: item.chat?true:false,
            active: item.active?true:false,
            sort: item.sort!=0?item.sort:"-",
            date: item.createdAt,
           }
        })
    }
}